<template>
    <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
        <i class="fal fa-spinner fa-spin" /> Schedule Data Loading...</div>
    <div v-else class="animated fadeIn">
        <BasicHeading title="Instrument Runner" class="mb-3" />
        <ContextPills :items="badges" />
        <InstrumentRunnerBody :schedule="schedule" />
    </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import ContextPills from "@/components/shared/ContextPills";
import InstrumentRunnerBody from "@/components/lab/instrumentrunner/InstrumentRunnerBody";
import { getModel } from "@/shared/fetch-utils";
import moment from "moment";

export default {
    name: "InstrumentRunnerScheduleDetail",
    components: {
        BasicHeading,
        ContextPills,
        InstrumentRunnerBody,
    },
    data() {
        return {
            scheduleId: this.$route.params.scheduleId,
            schedule: null,
            badges: [],
            loading: true,
            dateFormat: "dddd, MMMM Do, YYYY",
        };
    },
    methods: {
        async init() {
            await this.getSchedule();
        },
        initBadges() {
            const schedule = {
                faIcon: "calendar",
                label: moment(this.schedule.date).format(this.dateFormat),
                variant: "primary"
            };

            const sampleType = {
                faIcon: "shovel",
                label: this.schedule.sample_type.name,
                variant: "dark"
            };

            const processType = {
                label: this.schedule.process_type,
                variant: "dark"
            };

            this.badges.push(schedule, processType, sampleType);
        },
        async getSchedule() {
            this.loading = true;

            // get the schedule id from the route
            this.schedule = await getModel({
                model_type: "schedule",
                id: this.scheduleId,
                message: this.$bvToast,
            });

            this.loading = false

            if (this.schedule) {
                this.initBadges();
            } else {
                this.$router.back();
            }
        },
    },
    mounted() {
        this.init();
    },
}
</script>
